<template>
  <div class="page parcel-detail">
    <div class="container mt-4">
      <h1>{{ $t("page.labels.enquiry_incidence") }}</h1>
      <h4 class="mt-5" v-if="coordinator_description">
        {{ $t("page.labels.comment_incidence") }}
      </h4>
      <p class="my-2">
        {{ this.coordinator_description }}
      </p>
      <h4 class="mb-2">
        {{ $t("page.labels.write_doubts") }}
      </h4>
      <form
        id="formCreateEnquiry"
        @submit.prevent="createEnquiry"
        method="post"
        action="#"
      >
        <textarea
          class="textarea is-black has-fixed-size"
          name="description"
          v-model="description"
          required
          id="taDescription"
          rows="6"
        ></textarea>
        <div class="field is-grouped is-grouped-right">
          <p class="control">
            <button class="mt-1 button is-link is-outlined" type="submit">
              {{ $t("page.buttons.send") }}
            </button>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from "@/api"

export default {
  name: "incidence-open-enquiry",
  mounted() {
    this.getCoordinatorDescription()
  },
  data() {
    return {
      coordinator_description: null,
      description: "",
    }
  },
  methods: {
    getCoordinatorDescription() {
      this.coordinator_description = this.$store.state.incidence.coordinator_description
    },
    createEnquiry() {
      api.createEnquiry(this.$route.params.id, this.description).then((response) => {
        this.$router.push({
          name: "enquiry-chat",
          params: { enquiryId: response.data.id },
        })
      })
    },
  },
}
</script>
